import styled from 'styled-components';

export const StyledContainer = styled.div`
	h2 {
		text-align: center;
	}
	width: 30%;
	margin: auto;
	padding: 32px;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		width: 40%;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		width: 100%;
	}
`;
export const StyledTitleContainer = styled.div`
	margin-top: 12px;
	margin-bottom: 24px;
`;
export const StyledError = styled.p`
	color: ${({ theme }) => theme.colors.error};
`;
export const StyledSuccess = styled.p`
	color: ${({ theme }) => theme.colors.success};
	text-align: center;
`;
export const StyledBlock = styled.span`
	width: 100%;
	display: inline-block;
	position: relative;
`;
export const StyledVersionContainer = styled.div`
	display: flex;
	flex-direction: column;
	color: ${({ theme }) => theme.colors.muted};
	font-size: 14px;
`;
export const StyledModifyPassword = styled.div`
	color: ${({ theme }) => theme.colors.muted};
	text-decoration: underline;
	display: inline-block;
	position: relative;
`;
